import { createSlice } from '@reduxjs/toolkit'


export const projectsSlice = createSlice({
    name: 'projects',
    initialState: {
        value: [
            {"name": "mfs", "display": "MFS", "permission": null, "order": 1},
            {"name": "tech", "display": "TA", "permission": "view_project_tech", "order": 8},
            {"name": "mfsrank", "display": "MFS RP", "permission": null, "order": 2},
        ]
    },
    reducers: {
        clear: state => {state.value = []},
        setProjectsList: (state, action) => {
            state.value = action.payload
        }
    }
})

// Action creators are generated for each case reducer function
export const { clear, setProjectsList } = projectsSlice.actions

export default projectsSlice.reducer